// @flow
import React, { Component } from 'react';
import { Switch, Route, NavLink } from 'react-router-dom';
import {
  SubNavTabsDiv,
  SalesMaterialContainerDiv
} from './SalesMaterialStyles';

import { type MarketingFile } from '../';
import SalesMaterialList from './SalesMaterialList';
import { Default } from '../../../components/Responsive';
import {
  paymentPartnerOptions,
  customPartnerOptions,
  merchantSalesMaterialOptions,
  salesMaterialVideosOptions
} from './SalesMaterialOptions';
import { ProgressTabsDiv, TabH5 } from '../../../components/ProgressTabStyles';

type Props = {
  salesMaterialMerchants: MarketingFile[],
  salesMaterialPartners: MarketingFile[],
  customSalesMaterials: MarketingFile[],
  salesVideos: MarketingFile[],
  salesMaterialFilter: string,
  setSalesMaterialFilter: (salesMaterialCategory: ?string) => void,
  downloadFile: (url: string, fileName: string) => void,
  location: {
    pathname: string
  }
};

export default class SalesMaterial extends Component<Props> {
  componentWillUnmount() {
    this.props.setSalesMaterialFilter(null);
  }
  componentDidUpdate(prevProps: Props) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.props.setSalesMaterialFilter(null);
    }
  }
  render() {
    return (
      <SalesMaterialContainerDiv>
        <SubNavTabsDiv>
          <ProgressTabsDiv>
            <NavLink to="/marketing/sales-materials">
              <TabH5
                mobileActiveBorderRight
                vertical
                active={
                  this.props.location.pathname === '/marketing/sales-materials'
                }
              >
                Merchants
              </TabH5>
            </NavLink>
            <NavLink to="/marketing/sales-materials/payment-partners">
              <TabH5
                vertical
                mobileActiveBorderRight
                active={
                  this.props.location.pathname ===
                  '/marketing/sales-materials/payment-partners'
                }
              >
                Partners
              </TabH5>
            </NavLink>
            <NavLink to="/marketing/sales-materials/custom-materials">
              <TabH5
                mobileActiveBorderRight
                vertical
                active={
                  this.props.location.pathname ===
                  '/marketing/sales-materials/custom-materials'
                }
              >
                Custom <Default>Material</Default>
              </TabH5>
            </NavLink>
            <NavLink to="/marketing/sales-materials/videos">
              <TabH5
                mobileActiveBorderRight
                vertical
                active={
                  this.props.location.pathname ===
                  '/marketing/sales-materials/videos'
                }
              >
                Videos
              </TabH5>
            </NavLink>
          </ProgressTabsDiv>
        </SubNavTabsDiv>
        <div>
          <Switch>
            <Route
              exact
              path="/marketing/sales-materials/payment-partners"
              render={props => (
                <SalesMaterialList
                  {...props}
                  marketingFiles={this.props.salesMaterialPartners}
                  salesMaterialFilterOptions={paymentPartnerOptions}
                  // salesMaterialPartners={this.props.salesMaterialPartners}
                  salesMaterialFilter={this.props.salesMaterialFilter}
                  setSalesMaterialFilter={this.props.setSalesMaterialFilter}
                  downloadFile={this.props.downloadFile}
                />
              )}
            />
            <Route
              exact
              path="/marketing/sales-materials/custom-materials"
              render={props => (
                <SalesMaterialList
                  {...props}
                  marketingFiles={this.props.customSalesMaterials}
                  salesMaterialFilterOptions={customPartnerOptions}
                  salesMaterialFilter={this.props.salesMaterialFilter}
                  setSalesMaterialFilter={this.props.setSalesMaterialFilter}
                  downloadFile={this.props.downloadFile}
                />
              )}
            />
            <Route
              exact
              path="/marketing/sales-materials/videos"
              render={props => (
                <SalesMaterialList
                  {...props}
                  marketingFiles={this.props.salesVideos}
                  salesMaterialFilterOptions={salesMaterialVideosOptions}
                  salesMaterialFilter={this.props.salesMaterialFilter}
                  setSalesMaterialFilter={this.props.setSalesMaterialFilter}
                  downloadFile={this.props.downloadFile}
                />
              )}
            />
            <Route
              path="/marketing"
              render={props => (
                <SalesMaterialList
                  {...props}
                  marketingFiles={this.props.salesMaterialMerchants}
                  salesMaterialFilterOptions={merchantSalesMaterialOptions}
                  salesMaterialFilter={this.props.salesMaterialFilter}
                  setSalesMaterialFilter={this.props.setSalesMaterialFilter}
                  downloadFile={this.props.downloadFile}
                />
              )}
            />
          </Switch>
        </div>
      </SalesMaterialContainerDiv>
    );
  }
}
